var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.header = new (function () {
    var self = this;
    this.init = function () {
        this.removeBorder();
        this.notifications();
    };

    this.removeBorder = function () {
        if (
            $("#content").children(".frontpage-hero").length != 0 ||
            $("#content").children(".page-hero").length != 0
        ) {
            $("#header").css("border", "none");
        }
    };

    this.notifications = function () {
        $(".header-actions-notification").on("click", function () {
            $(".notifications").fadeToggle();
            if ($("body").hasClass("body-overflow--hidden")) {
                $(".nav-main-mobile").removeClass("nav-main-mobile--show");
                $("body").removeClass("body-overflow--hidden");
            }
        });
    };
})();
